import { Fragment, ReactElement } from 'react';
import { Container, styled } from '@mui/material';
import { ValueLabel, FocusLabelButton, variables } from '../common';
import { ICsaRequestStatus, csaSortPropertyMap, showCsa, sortable } from '.';
import { pathOr } from 'rambda';
import {
  map as lmap,
  compose as lcompose,
  compact as lcompact,
} from 'lodash/fp';
import { left, right, fold } from 'fp-ts/lib/Either';

export const renderCsa =
  (s: any) =>
  (properties: ValueLabel<keyof ICsaRequestStatus>[]) =>
  ({
    sortBy,
    sortDirection,
    toggleSort,
  }: {
    sortBy: string;
    sortDirection: 'asc' | 'desc';
    toggleSort: (name: string) => void;
  }) =>
    lcompose(
      fold(
        () => <Container maxWidth="lg">Empty</Container>,

        deaRegistrations => (
          <Container maxWidth="xl">
            <Article>
              {lmap<ValueLabel<string>, ReactElement>(({ value, label }) => (
                <h4 key={label}>
                  {sortable(csaSortPropertyMap)(value) ? (
                    <FocusLabelButton
                      name={pathOr('', value)(csaSortPropertyMap)}
                      label={label}
                      sortBy={sortBy}
                      sortDirection={sortDirection}
                      onClick={() =>
                        toggleSort(pathOr('', value)(csaSortPropertyMap))
                      }
                    />
                  ) : (
                    <span>{label}</span>
                  )}
                </h4>
              ))(properties)}

              {lmap<ICsaRequestStatus, ReactElement>(
                lcompose(
                  ([a, b]) => <Fragment key={a.requestId}>{b}</Fragment>,
                  ([a, b]) => [a, lcompact(b)],
                  a => [
                    a,
                    [
                      ...lmap<
                        ValueLabel<keyof ICsaRequestStatus>,
                        ReactElement | undefined
                      >(({ value }) => (
                        <SpanPV key={`${a.id}-${value}`}>
                          {showCsa(value)(a)}
                        </SpanPV>
                      ))(properties),
                    ],
                  ]
                )
              )(deaRegistrations)}
            </Article>
          </Container>
        )
      ),

      (requests: ICsaRequestStatus[]) =>
        requests.length === 0 ? left(requests) : right(requests)
    );

const Article = styled('article')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',

  '&>*+*': {
    marginTop: '1rem',
  },

  '@media (min-width: 60em)': {
    display: 'grid',
    gridTemplateColumns: 'repeat(16, auto) ',
    gridAutoRows: 'minmax(auto, 5em)',
    gap: '1px',

    backgroundColor: variables.grayLighter,
    border: variables.cardBorder,
    borderRadius: variables.cardBorderRadius,

    '&>*': {
      backgroundColor: '#fff',
      padding: '1rem',
    },

    '&>*+*': {
      marginTop: '0rem',
    },
  },
}));

const SpanPV = styled('span')(({ theme }) => ({
  overflow: 'auto',
  overflowWrap: 'break-word',
}));
